import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.COMMENTS_FETCH_SUCCESS,
    actions.COMMENTS_RECEIVED
  ],
  updateSuccessTypes: [actions.COMMENT_UPDATE],
  updateKey: 'commentId',
  entityType: 'comments'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/byId/reducer.js
 **/